<template>
    <div class="container-fluid">
        <b-modal id="bv-modal-settings-save-error" hide-footer>
            <div class="d-block text-center">
              <h3>{{$t('saved_error')}}</h3>
            </div>
            <b-button block variant="danger" @click="$bvModal.hide('bv-modal-settings-save-error')">Ок</b-button>
        </b-modal>
        <b-card no-body bg-variant="dark">
            <span v-if="loading">
            <b-spinner label="Spinning"></b-spinner>
            </span>
            <span v-else>
                <b-tabs pills card vertical fill class="container-fluid align-top p-0">
                    <b-tab no-body :title="$t('settings.device_passport')"  :active="activeSection.passport">
                        <b-card no-body class="border-0"  bg-variant="dark">
                            <Passport v-bind:id="deviceId" ref="devicePassport"
                                @identity:pending="$emit('identity:pending')"
                                @identity:changed="$emit('identity:changed')" />
                        </b-card>
                    </b-tab>
                    <b-tab no-body :title="$t('settings.firmware')" :active="activeSection.firmware">
                        <b-card no-body class="border-0"  bg-variant="dark">
                            <Firmware
                                v-bind:id="deviceId"
                                v-on:device:changed="reloadComponent()"
                            />
                        </b-card>
                    </b-tab>
                    <b-tab no-body :title="$t('settings.configuration')" :active="activeSection.configuration">
                        <b-card no-body class="border-0"  bg-variant="dark">
                            <Configuration
                                v-bind:id="deviceId"
                                v-on:device:changed="reloadComponent()"
                            />
                        </b-card>
                    </b-tab>
                    <b-tab v-if="serviceTextAvailable()" no-body :title="$t('settings.device_service_text')"  :active="activeSection.serviceText">
                        <b-card no-body class="border-0"  bg-variant="dark">
                            <ServiceText v-bind:id="deviceId" ref="serviceText"/>
                        </b-card>
                    </b-tab>
                    <b-tab v-on:click="setCoordinatesSelected()" v-if="brandConfig.showDeviceMonitoring && coordinatesAvailable" no-body :title="$t('settings.monitoring')">
                        <b-card no-body class="border-0"  bg-variant="dark">
                            <DeviceSettingsMap
                                v-bind:id="deviceId"
                                v-bind:imei="deviceImei"
                                v-bind:visible="coordinatesSelected"
                            />
                        </b-card>
                    </b-tab>
                  <b-tab v-on:click="setCoordinatesHistoryCoordinatesSelected()" v-if="brandConfig.showDeviceMonitoring && coordinatesAvailable" no-body :title="$t('settings.track')">
                        <b-card no-body class="border-0"  bg-variant="dark">
                            <MonitoringHistoryCoordinates
                                v-bind:id="deviceId"
                                v-bind:visible="coordinatesHistoryCoordinatesSelected"
                            />
                        </b-card>
                    </b-tab>
                  <b-tab v-on:click="setCoordinatesHistorySelected()" v-if="brandConfig.showDeviceMonitoring && coordinatesAvailable" no-body :title="$t('settings.packets')">
                        <b-card no-body class="border-0"  bg-variant="dark">
                            <MonitoringHistory
                                v-bind:id="deviceId"
                                v-bind:visible="coordinatesHistorySelected"
                            />
                        </b-card>
                    </b-tab>


                    <b-tab disabled no-body>
                        <template v-slot:title>
                            <hr/>
                      </template>
                        </b-tab>
                    <b-tab :title="$t('settings.device_settings')" disabled no-body>{{$t('settings.device_settings')}}</b-tab>

                    <b-tab no-body
                            v-for="section in configuration.sectionList"
                            :key="section.id"
                            :title= "' ' + section.name"
                            :suffix="section.id"
                    >
                        <template v-slot:title>
                            <div class="d-flex">
                              <span class="ml-3">{{section.name}}</span>
                                  <span v-if="section.errors > 0" class="fa-stack ml-auto">
                                  <span style="color: red">
                                    {{section.errors}}
                                </span>

                              </span>
                            </div>                        </template>
                        <b-card no-body class="border-0" bg-variant="dark">
                            <SettingsSection
                                    :section="section"
                                    :configuration="configuration"
                                    :device-settings.sync="deviceSettings"
                                    :url="'api/v1/devices/'+ deviceImei + '/settings'"
                                    v-on:save:settings="saveSettings($event)"
                                    v-on:update:settings="updateSettings($event)"
                                    v-on:update:changed="saveChanged($event)"
                                    :changed="changed"
                                    :show-success-alert.sync="showSuccessAlert"
                            />
                        </b-card>
                    </b-tab>
                </b-tabs>
            </span>
        </b-card>
    </div>
</template>

<script>
    import {brandConfig} from '../../config/brand';
    import Passport from "./Passport.vue";
    import Firmware from "./Firmware.vue";
    import Configuration from "./Configuration.vue";
    import ServiceText from "./ServiceText.vue";
    import DeviceSettingsMap from "./Map.vue";
    import MonitoringHistory from "./MonitoringHistory.vue";
    import MonitoringHistoryCoordinates from "./MonitoringHistoryCoordinates.vue";
    import axios from "axios";
    import SettingsSection from "../Common/Settings/Section";


    export default {
        name: "DeviceSettings",
        components: {
            SettingsSection,
            Passport,
            Configuration,
            Firmware,
            DeviceSettingsMap,
            MonitoringHistory,
            MonitoringHistoryCoordinates,
            ServiceText
        },
        props: [
            "deviceId",
            "deviceTypeId",
            "deviceImei",
            "section"
        ],
        data() {
            return {
                brandConfig,
                loading: true,
                configurationLoaded: false,
                settingsLoaded: false,
                activeSection: {
                    passport: true,
                    firmware: false,
                    configuration: false,
                    serviceText: false,
                },
                futureAvailable: {
                    serviceText: false
                },
                configuration: {
                    sectionList: [],
                    settingViewList: {},
                    settingDictionaryList: {},
                    sectionErrorList: {},
                    hasErrors() {
                        return this.sectionList.some(section => section.errors > 0);
                    }
                },
                deviceSettings: {},
                changed: false,
                showSuccessAlert: false,
                coordinatesAvailable: false,
                coordinatesSelected: false,
                coordinatesHistoryCoordinatesSelected: false,
                coordinatesHistorySelected: false,
            }
        },
        mounted() {
            this.loadData();
            this.setActiveSection(this.section)
        },
        methods: {
            loadData() {
                let props = this;

                this.loading = true;
                this.configurationLoaded = false;
                this.settingsLoaded = false;

                this.configuration = {
                    sectionList: [],
                        settingViewList: {},
                    settingDictionaryList: {},
                    sectionErrorList: {},
                    hasErrors() {
                        return this.sectionList.some(section => section.errors > 0);
                    }
                }

                this.initFutureAvailable();

                this.deviceSettings = {};
                this.changed = false;
                this.showSuccessAlert = false;

                axios
                    .get('api/v1/devices/' + this.deviceId + '?lang=' + this.lang)
                    .then((data) => {
                        const device = data.data;

                        this.coordinatesAvailable = device.coordinatesAvailable;

                    })
                    .catch(() => undefined);

                axios
                    .get('api/v1/devices/'+ props.deviceImei + '/configuration?_locale=' + this.lang)
                    .then((resp) => {
                        const response = resp.data.data;

                        response.sectionList.forEach(
                            section => {
                                let sec = section;
                                sec.errors = 0;
                                this.configuration.sectionList.push(sec)
                            }
                        )

                        response.settingViewList.forEach(
                            settingView => {
                                this.configuration.settingViewList[settingView.alias] = {
                                    alias: settingView.alias,
                                    defaultValue: settingView.defaultValue,
                                    textAfter: settingView.textAfter,
                                    textBefore: settingView.textBefore,
                                    type: settingView.type,
                                    widget: settingView.widget,
                                    readonly: settingView.readonly === true,
                                    hint: settingView.hint,
                                    rules: {}
                                };
                            }
                        )

                        response.settingDictionaryList.forEach(
                            settingViewDictionary => {
                                let items = [];

                                settingViewDictionary.items.forEach(
                                    item => {
                                        items.push({
                                            item: item.number,
                                            name: item.name,
                                            notEnabled: item.notEnabled === true,
                                            hint: item.hint
                                        })
                                    }
                                )
                                if (this.configuration.settingViewList[settingViewDictionary.settingView] !== null) {
                                    this.configuration.settingViewList[settingViewDictionary.settingView].dictionary = items;
                                }
                            }
                        )

                        response.settingValidationRuleList.forEach(
                            settingValidationRuleList => {
                                let rules = {};

                                settingValidationRuleList.rules.forEach(
                                    item => {
                                        switch (item.type) {
                                            case 'regexp':
                                                rules.regex = item.properties.regexp;
                                                break;
                                            case 'number':
                                                rules.between = {
                                                    min: item.properties.min,
                                                    max: item.properties.max
                                                };
                                                break;
                                            case 'dns_ip':
                                                // eslint-disable-next-line
                                                rules.regex = "^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$|^(?:(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){6})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:::(?:(?:(?:[0-9a-fA-F]{1,4})):){5})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})))?::(?:(?:(?:[0-9a-fA-F]{1,4})):){4})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,1}(?:(?:[0-9a-fA-F]{1,4})))?::(?:(?:(?:[0-9a-fA-F]{1,4})):){3})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,2}(?:(?:[0-9a-fA-F]{1,4})))?::(?:(?:(?:[0-9a-fA-F]{1,4})):){2})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,3}(?:(?:[0-9a-fA-F]{1,4})))?::(?:(?:[0-9a-fA-F]{1,4})):)(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,4}(?:(?:[0-9a-fA-F]{1,4})))?::)(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,5}(?:(?:[0-9a-fA-F]{1,4})))?::)(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,6}(?:(?:[0-9a-fA-F]{1,4})))?::))))$"
                                                break;
                                            case 'maxlength':
                                                rules.max = item.properties.value;
                                                break;
                                            case 'required':
                                                rules.required = true;
                                                break;
                                        }

                                        // rules.push({
                                        //     type: item.type,
                                        //     name: item.name,
                                        //     properties: item.properties
                                        // })
                                    }
                                )
                                if (
                                    this.configuration.settingViewList[settingValidationRuleList.setting_view_alias] !== null
                                ) {
                                    this.configuration.settingViewList[settingValidationRuleList.setting_view_alias].rules = rules;
                                    //console.log(items)
                                }
                            }
                        )

                        this.configurationLoaded = true;
                        this.finishLoading();
                        // console.log(this.configuration.settingViewList);
                    });

                axios
                    .get('api/v1/devices/'+ props.deviceImei + '/settings')
                    .then((resp) => {
                        const response = resp.data.data;

                        response.forEach(
                            item => {
                                this.deviceSettings[item.alias] = item.value;
                            }
                        );

                        this.settingsLoaded = true;
                        this.finishLoading();
                    });
            },
            finishLoading() {
                if (this.configurationLoaded && this.settingsLoaded) {
                    this.loading = false;
                }
            },
            saveChanged() {
                this.changed = true
            },
            serviceTextAvailable() {return this.deviceTypeId >= 217;},
            setCoordinatesSelected() {
                this.coordinatesSelected=true;
            },
            setCoordinatesHistoryCoordinatesSelected() {
                this.coordinatesHistoryCoordinatesSelected=true;
            },
            setCoordinatesHistorySelected() {
                this.coordinatesHistorySelected=true;
            },
            updateSettings(formData) {
                for (let setting in formData) {
                    this.deviceSettings[setting] = formData[setting].value;
                }
                // console.log(formData)
                // console.log(this.deviceSettings)
            },
            initFutureAvailable() {
                let futureAvailable = {};

                if (localStorage.getItem('futureAvailable')) {
                    try {
                        futureAvailable = JSON.parse(localStorage.getItem('futureAvailable'));
                    } catch(e) {
                        localStorage.removeItem('futureAvailable');
                        return;
                    }
                }

                this.futureAvailable.serviceText = futureAvailable.serviceText;
            },
            saveSettings() {
                // console.log(this.deviceSettings)

                if (this.configuration.hasErrors()){
                        alert('errors');
                        return;
                }

                let settings = [];

                for (let alias in this.deviceSettings) {
                    settings.push({alias: alias, value: this.deviceSettings[alias]})
                }

                const data = {'settings': settings};

                axios
                    .post('api/v1/devices/'+ this.deviceImei + '/settings', data)
                    .then(() => {
                        // console.log(response + undefined);
                        this.showSuccessAlert = true
                    })
                    .catch(() => {

                        // console.log(error);
                        this.$bvModal.show('bv-modal-settings-save-error')
                    })

            },
            setActiveSection(section) {
                if (Object.getOwnPropertyDescriptor(this.activeSection, section)) {
                    for (let prop in this.activeSection) {
                        this.activeSection[prop] = false;
                    }

                    this.activeSection[section] = true;
                }
            },
            reloadComponent() {
                this.$refs.devicePassport.loadData();
                this.loadData();
                this.$forceUpdate();
            },
        },
        computed: {
            lang : {
                get() {
                    return this.$store.getters.getLang
                },
            }
        },
    }
</script>

<style scoped>

</style>
